<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_4"></a>First published in the United States in 2013 by Chronicle Books.</p>
<p class="copyrightt">First Published in the United Kingdom in 2011 by Hodder &amp; Stoughton, an Hachette UK company.</p>
<p class="copyrightt">Text and illustrations copyright</p>
<p class="copyright">© 2013 by Andy Riley.</p>
<p class="copyrightt">All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p class="copyrightt">ISBN 978-1-4521-2692-0</p>
<p class="copyrightt">The Library of Congress has cataloged the previous edition as follows:</p>
<p class="copyrightt">Riley, Andy.</p>
<p class="copyrighta">Beer makes daddy strong / Andy Riley.</p>
<p class="copyrightc">p. cm.</p>
<p class="copyrighta">ISBN 978-1-4521-1208-4</p>
<p class="copyrighta1">1. English wit and humor, Pictorial. 2. Fathers--Caricatures and cartoons. 3. Fatherhood--Caricatures and cartoons. I. Title.</p>
<p class="copyrightat">NC1479.R55A4 2013b</p>
<p class="copyrighta">741.5’6941--dc23</p>
<p class="copyrightr">2012026429</p>
<p class="copyright2">Chronicle Books, LLC</p>
<p class="copyright">680 Second Street</p>
<p class="copyright">San Francisco, California 94107</p>
<p class="copyright"><span class="weblink"><a href="http://www.chroniclebooks.com" target="_blank">www.chroniclebooks.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?205d93fe